import LogicFlow from '@logicflow/core'

export const StartEventConfig = {
  width: 40,
  height: 40,
}

export const EndEventConfig = {
  width: 40,
  height: 40,
}

export const ExclusiveGatewayConfig = {
  width: 40,
  height: 40,
}

export const ServiceTaskConfig = {
  width: 100,
  height: 80,
}

export const UserTaskConfig = {
  width: 100,
  height: 80,
}

export const theme: Partial<LogicFlow.Theme> = {
  rect: {
    radius: 5,
    stroke: 'rgb(24, 125, 255)',
  },
  circle: {
    r: 18,
    stroke: 'rgb(24, 125, 255)',
  },
  polygon: {
    stroke: 'rgb(24, 125, 255)',
  },
  polyline: {
    stroke: 'rgb(24, 125, 255)',
    hoverStroke: 'rgb(24, 125, 255)',
    selectedStroke: 'rgb(24, 125, 255)',
  },
  edgeText: {
    textWidth: 100,
    overflowMode: 'default',
    fontSize: 12,
    background: {
      fill: 'white',
      height: 14,
      stroke: 'transparent',
      radius: 3,
    },
  },
}
